// Define functions outside of DOMContentLoaded to make them reusable

function fullWidthMediaFunc() {
    const fullWidthMediaContainer = document.querySelector('.full-width-media-gallery');
    const closeButton = fullWidthMediaContainer ? fullWidthMediaContainer.querySelector('.full-width-media-close-button') : null;
    const body = document.body;
    const productMediaWrapper = document.querySelector('.product__media-wrapper');

    if (fullWidthMediaContainer) {
        fullWidthMediaContainer.setAttribute('open', '');
        body.style.overflow = 'hidden';
        productMediaWrapper.style.zIndex = '1001';
    }

    if (closeButton) {
        closeButton.addEventListener('click', () => {
            if (fullWidthMediaContainer) {
                fullWidthMediaContainer.removeAttribute('open');
                body.style.overflow = '';
                setTimeout(() => productMediaWrapper.style.zIndex = '', 300);
            }
        });
    }
}

function enableZoomHover(zoomRatio) {
    const images = document.querySelectorAll('.image-magnify-hover');

    images.forEach(image => {
        image.addEventListener('mouseenter', (event) => {
            zoomFunction(image, zoomRatio);
            containerPanel(image, zoomRatio);
            moveWithHover(image, event, zoomRatio);
        });

        image.addEventListener('click', fullWidthMediaFunc);
    });
}

function zoomFunction(image, zoomRatio) {
    const panel = createPanel(image);
    const overlay = image;

    const mouseLeaveHandler = () => {
        // Remove all panels
        document.querySelectorAll('.image-magnify-full-size').forEach(p => p.remove());

        // Remove bounding box
        containerPanelRemove();

        // Remove open attribute from zoomContainer
        const zoomContainer = document.querySelector('.product__zoom-wrapper');
        if (zoomContainer) {
            zoomContainer.removeAttribute('open');
        }

        // Remove the mouseleave event listener
        overlay.removeEventListener('mouseleave', mouseLeaveHandler);
    };

    overlay.addEventListener('mouseleave', mouseLeaveHandler);

    overlay.addEventListener('mousemove', (event) => {
        moveWithHover(panel, event, zoomRatio);
    });
}

function createPanel(image) {
    const panel = document.createElement('div');
    panel.setAttribute('class', 'image-magnify-full-size');

    preparePanel(panel, image);

    // Adding panel to .drift-zoom-pane
    const zoomContainer = document.querySelector('.product__zoom-wrapper');
    const zoomPane = zoomContainer ? zoomContainer.querySelector('.drift-zoom-pane') : null;

    if (zoomPane) {
        zoomContainer.setAttribute('open', ''); // 设置 open 属性
        zoomPane.appendChild(panel);
    }

    return panel;
}

function preparePanel(panel, image) {
    panel.setAttribute('class', 'image-magnify-full-size');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.backgroundImage = `url('${image.src}')`;
    panel.style.backgroundColor = 'var(--gradient-background)';
}

function moveWithHover(panel, event, zoomRatio) {
    requestAnimationFrame(() => {
        const container = event.target.getBoundingClientRect();
        const xPosition = event.clientX - container.left;
        const yPosition = event.clientY - container.top;

        const ratio = panel.offsetHeight / panel.offsetWidth;
        const xPercent = `${(xPosition / container.width) * 100}%`;
        const yPercent = `${(yPosition / (container.width * ratio)) * 100}%`;

        panel.style.backgroundPosition = `${xPercent} ${yPercent}`;
        panel.style.backgroundSize = `${panel.offsetWidth * zoomRatio}px ${panel.offsetHeight * zoomRatio}px`;

        containerPanelUpdate(panel, event, zoomRatio);
    });
}

function containerPanel(image, zoomRatio) {
    let boundingBox = document.querySelector('.drift-bounding-box');
    
    if (!boundingBox) {
        boundingBox = document.createElement('div');
        boundingBox.setAttribute('class', 'drift-bounding-box');
        const parent = image.parentElement;
        if (parent) {
            parent.appendChild(boundingBox);
        }
    }
    
    const container = image.getBoundingClientRect();
    const boxWidth = image.offsetWidth / zoomRatio;
    const boxHeight = image.offsetHeight / zoomRatio;

    boundingBox.style.width = `${boxWidth}px`;
    boundingBox.style.height = `${boxHeight}px`;
}

function containerPanelUpdate(panel, event, zoomRatio) {
    const boundingBox = document.querySelector('.drift-bounding-box');
    if (boundingBox) {
        const container = event.target.getBoundingClientRect();
        const xPosition = event.clientX - container.left;
        const yPosition = event.clientY - container.top;

        boundingBox.style.left = `${xPosition - (boundingBox.offsetWidth / 2)}px`;
        boundingBox.style.top = `${yPosition - (boundingBox.offsetHeight / 2)}px`;
    }
}

function containerPanelRemove() {
    const boundingBox = document.querySelector('.drift-bounding-box');
    if (boundingBox) {
        boundingBox.remove();
    }
}

function setPanelPosition() {
    const leftWrapper = document.querySelector('.product__info-wrapper');
    const topWrapper = document.querySelector('.product__media-wrapper');
    const zoomWrapper = document.querySelector('.product__zoom-wrapper');

    if (leftWrapper && topWrapper && zoomWrapper) {
        const updatePosition = () => {
            const topRect = topWrapper.getBoundingClientRect();
            const leftRect = leftWrapper.getBoundingClientRect();
            // 计算 topWrapper 实际距离浏览器顶部的值
            const topOffset = topRect.top;

            zoomWrapper.style.top = `${topOffset}px`;
            zoomWrapper.style.left = `${leftRect.left + window.scrollX}px`;
        };

        // Initial position update
        updatePosition();

        // Update position on scroll
        window.addEventListener('scroll', updatePosition);

        // Update position on resize with debounce
        let resizeTimeout;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                updatePosition();
            }, 2000); // 2 seconds debounce
        });
    }
}

// Register the functions to be executed when DOMContentLoaded event fires
document.addEventListener('DOMContentLoaded', () => {
    enableZoomHover(4); // Pass desired zoomRatio here
    setPanelPosition(); // 调用 setPanelPosition
});
